<script lang="ts">
  import type { MediaItem } from "../../types/subsplash.d.ts";
  import { type CardProps } from "../content/Card.svelte";
  import { convertStatamicAssetToCDN } from "@utils/cdn";
  import CardSlider from "@components/content/CardSlider.svelte";
  import { stripHtml } from "@utils/string.ts";
  export let mediaItems: MediaItem[];
  export let currentItem: number = 0;

  function convertStatamicSessionToContent(mediaItem: MediaItem): CardProps {
    // const slug = `/experiences/${statamicSession.slug}`;

    let output: CardProps = {
      title: mediaItem.title,
      leader: mediaItem.subtitle,
      description: stripHtml(mediaItem.summary) || mediaItem.description,
      href: mediaItem.uri,
      trimDescriptionLength: 175,
      // tag: `Session ${statamicSession.session_number}`,
      featuredImageSrc:
        convertStatamicAssetToCDN(mediaItem?.images?.square?.id) ||
        mediaItem?._embedded?.images
          .find((image) => image.type === "wide")
          ?._links.dynamic.href.replace("{name}", "image")
          .replace("{ext}", "jpg")
          .replace("{width}", 640)
          .replace("{height}", 360),
      isFocused: currentItem === mediaItems.length - mediaItem.position,
      leftCTA: undefined,
    };
    if (!!mediaItem._embedded?.video) {
      output.leftCTA = {
        text: `Play`,
        href: mediaItem.uri,
        leftIcon: { name: "playOutline" },
      };
    }

    return output;
  }
</script>

<CardSlider
  startIndex={currentItem}
  cards={mediaItems.map(convertStatamicSessionToContent)}
/>
